import { fulfilled, failed, pending } from "lib/promiseMiddlewareTypes";
import initialState from "store/initialState";
import { GET_CONFIG } from "actions/config";

const loadingConfig = (state = initialState.loadingConfig, action: any) => {
  switch (action.type) {
    case pending(GET_CONFIG):
      return true;
    case fulfilled(GET_CONFIG):
    case failed(GET_CONFIG):
      return false;
    default:
      return state;
  }
};

export default loadingConfig;
